import React, { useEffect, useRef, useState } from 'react';
import { Button, FormControl, Input, Snackbar, Avatar, Typography, Divider, Chip, Select, Option } from '@mui/joy';
import { Delete, Report } from '@mui/icons-material';
import { useAuth } from '../../context/authContext';

import LoadingSpinnerComponent from '../LoadingSpinnerComponent';

import '../../styles/reviews.scss';

const networking = require('../../Networking/AuthenticationAPI');
const helper = require('../../Helpers/helpers');

function TeamManagementComponent({ subscription }: any) {
    const { token } = useAuth();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showError, setShowError] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [success, setSuccess] = useState('');
    const [ownerUser, setOwnerUser] = useState<any>(null);
    const [currentUser, setCurrentUser] = useState<any>(null);
    const [teamMembers, setTeamMembers] = useState<any>([]);
    const [invites, setInvites] = useState<any>(null);

    const currentDomain = window.location.origin;
    const hasFetched = useRef(false);
    const members = subscription.plan === 'AA' ? 3 : subscription.plan === 'AAA' ? 5 : subscription.plan === 'U' ? 10 : 0;

    useEffect(() => {
        if (!hasFetched.current) {
            getUserData();
            hasFetched.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function getUserData() {
        setLoading(true);
        networking.getUser(token)
            .then((response: any) => {
                setLoading(false);
                setCurrentUser(response.user);
                setOwnerUser(response.owner);
            })
            .catch((error: any) => {
                setLoading(false);
                setError(error.message);
                setShowError(true);
            });

        networking.getTeam(token)
            .then((response: any) => {
                setLoading(false);
                setTeamMembers(response);
            })
            .catch((error: any) => {
                setLoading(false);
            });

        getInvites();
    }

    function sendInvite(event: any) {
        setLoading(true);

        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());

        networking.sendInvite(token, formJson.email, subscription.id, formJson.role)
            .then((response: any) => {
                setLoading(false);

                setSuccess('Invite sent!');
                setShowSuccess(true);

                getInvites();
            })
            .catch((error: any) => {
                setLoading(false);
                setError(error.message);
                setShowError(true);
            });
    }

    function getInvites() {
        setLoading(true);
        networking.getInvites(token)
            .then((response: any) => {
                setLoading(false);
                setInvites(response.invites.filter((invite: any) => invite.status === 'pending'));
            })
            .catch((error: any) => {
                setLoading(false);
            });
    }

    function removeUser(userId: string, subscription_id: string) {
        networking.removeUser(token, userId, subscription_id).then(() => {
            setShowSuccess(true);
            setSuccess('User removed from team.');

            getUserData();

        }).catch((error: any) => {
            setError(error.message);
            setShowError(true);
        });
    }

    const copyToClipboard = (invite: any) => {
        setShowSuccess(true);
        setSuccess('Copied to clipboard.');
        console.log(`${currentDomain}/subscribe?token=${invite.token}`);
        navigator.clipboard.writeText(`${currentDomain}/subscribe?token=${invite.token}`);


        setSuccess('Link copied to clipboard');
        setShowSuccess(true);
    }

    return (
        <div className='p-2'>
            {showError &&
                <Snackbar
                    variant="soft"
                    color="danger"
                    open={showError}
                    onClose={() => setShowError(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Report />}
                    endDecorator={
                        <Button
                            onClick={() => setShowError(false)}
                            size="sm"
                            variant="soft"
                            color="danger"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    {error}
                </Snackbar>
            }
            {showSuccess &&
                <Snackbar
                    variant="soft"
                    color="success"
                    open={showSuccess}
                    onClose={() => setShowSuccess(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Report />}
                    endDecorator={
                        <Button
                            onClick={() => setShowSuccess(false)}
                            size="sm"
                            variant="soft"
                            color="success"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    {success}
                </Snackbar>
            }
            {loading ?
                <LoadingSpinnerComponent />
                :
                <>
                    {currentUser && currentUser.role === 'admin' &&
                        <>
                            {((teamMembers && (teamMembers.length + invites?.length) <= members)) &&
                                <>
                                    <Typography
                                        level='title-sm'>
                                        Invite new team member
                                    </Typography>
                                    <Typography
                                        level='body-xs'
                                        sx={{
                                            marginBottom: 1,
                                        }}>
                                        You can add up to {members} team members to your team.
                                    </Typography>
                                    <Divider
                                        sx={{
                                            marginBottom: 2,
                                        }} />

                                    <form
                                        onSubmit={sendInvite}>
                                        <div className='row'>
                                            <div className='col'>
                                                <FormControl>
                                                    <Input
                                                        name="email"
                                                        type="email"
                                                        placeholder="eg. teammember@domain.com"
                                                        size='lg'
                                                        required
                                                        sx={{ fontSize: '14px' }}
                                                    />
                                                </FormControl>
                                            </div>
                                            <div className='col-auto'>
                                                <FormControl>
                                                    <Select
                                                        required
                                                        color="neutral"
                                                        name="role"
                                                        placeholder="Role"
                                                        variant="outlined"
                                                        size='lg'
                                                        sx={{ fontSize: '14px' }}>
                                                        <Option
                                                            value="admin"
                                                            sx={{ fontSize: '14px' }}>
                                                            Admin
                                                        </Option>
                                                        <Option
                                                            value="member"
                                                            sx={{ fontSize: '14px' }}>
                                                            Member
                                                        </Option>
                                                    </Select>
                                                </FormControl>

                                            </div>
                                            <div className='col-auto'>
                                                <Button
                                                    type='submit'
                                                    size='lg'
                                                    sx={{
                                                        fontSize: '14px'
                                                    }}>
                                                    Send invite
                                                </Button>
                                            </div>
                                        </div>
                                    </form>
                                </>
                            }
                        </>
                    }
                    <Typography
                        sx={{
                            marginTop: 3,
                            marginBottom: 1,
                        }}
                        level='title-sm'>
                        My team
                    </Typography>
                    <Divider
                        sx={{
                            marginBottom: 2,
                        }} />
                    {ownerUser &&
                        <div className='row'>
                            <div className='col-auto'>
                                <Avatar
                                    color='primary'
                                    variant='solid'
                                    alt={ownerUser.name}
                                    src={ownerUser.profileimage}>
                                    {helper.getInitials(ownerUser.name)}
                                </Avatar>
                            </div>
                            <div className='col my-auto'>
                                <Typography
                                    level='title-sm'
                                    sx={{
                                        textAlign: 'left',
                                    }}>
                                    {ownerUser.name}
                                </Typography>
                            </div>
                            <div className='col my-auto'>
                                <Typography
                                    level='body-xs'
                                    sx={{
                                        textAlign: 'center',
                                    }}>
                                    {ownerUser.email}
                                </Typography>
                            </div>
                            <div className='col my-auto'>
                                <Typography
                                    level='body-xs'
                                    sx={{
                                        textAlign: 'center',
                                    }}>
                                    {helper.timeSince(ownerUser.last_login)}
                                </Typography>
                            </div>
                            <div className='col my-auto text-left'>
                                <Chip
                                    color='primary'
                                    size='sm'>
                                    {ownerUser.role}
                                </Chip>
                            </div>
                        </div>
                    }
                    <Divider
                        sx={{
                            marginTop: 2,
                            marginBottom: 2,
                        }} />
                    {teamMembers && teamMembers.map((member: any, index: number) => (
                        <div
                            key={index}
                            className='row mb-2'>
                            <div className='col-auto'>
                                <Avatar
                                    color='primary'
                                    variant='solid'
                                    alt={member.name}
                                    src={member.profileimage}>
                                    {helper.getInitials(member.name)}
                                </Avatar>
                            </div>
                            <div className='col my-auto'>
                                <Typography
                                    level='title-sm'
                                    sx={{
                                        textAlign: 'left',
                                    }}>
                                    {member.name}
                                </Typography>
                            </div>
                            <div className='col my-auto'>
                                <Typography
                                    level='body-xs'
                                    sx={{
                                        textAlign: 'center',
                                    }}>
                                    {member.email}
                                </Typography>
                            </div>
                            <div className='col my-auto'>
                                <Typography
                                    level='body-xs'
                                    sx={{
                                        textAlign: 'center',
                                    }}>
                                    {helper.timeSince(member.last_login)}
                                </Typography>
                            </div>
                            <div className='col my-auto text-center'>
                                <Chip
                                    color='success'
                                    size='sm'>
                                    {member.role}
                                </Chip>
                            </div>
                            <div className='col-auto my-auto'>
                                <Button
                                    variant='soft'
                                    size='sm'
                                    color='danger'
                                    onClick={() => removeUser(member.id, subscription.id)}>
                                    <Delete />
                                </Button>
                            </div>
                        </div>
                    ))}
                    {invites && invites.length > 0 &&
                        <>
                            <Typography
                                sx={{
                                    marginTop: 3,
                                    marginBottom: 1,
                                }}
                                level='title-sm'>
                                My pending invites
                            </Typography>
                            <Divider
                                sx={{
                                    marginTop: 2,
                                    marginBottom: 2,
                                }} />
                            {invites.map((invite: any) => (
                                <div className='row mb-2'>
                                    <div className='col-auto my-auto'>
                                        <Typography
                                            level='title-sm'
                                            sx={{
                                                textAlign: 'left',
                                            }}>
                                            {invite.email}
                                        </Typography>
                                    </div>
                                    <div className='col-auto my-auto'>
                                        <Typography
                                            level='body-sm'
                                            sx={{
                                                textAlign: 'left',
                                            }}>
                                            Copy this link and share it with the user you want to invite.
                                        </Typography>
                                    </div>
                                    <div className='col my-auto'>
                                        <Button
                                            variant='outlined'
                                            size='sm'
                                            onClick={() => (copyToClipboard(invite))}>
                                            Copy link
                                        </Button>
                                    </div>
                                    <div className='col-auto my-auto'>
                                        <Chip
                                            color={invite.status === 'pending' ? 'warning' : 'success'}
                                            size='sm'>
                                            {invite.status}
                                        </Chip>
                                    </div>
                                </div>
                            ))}
                        </>
                    }
                </>
            }
        </div >
    );
}

export default TeamManagementComponent;